export default "__VITE_ASSET__BjRQm8ot__"